export const formatModuleIconUrl = (
  fileName: string,
  color: 'white' | 'black' = 'black'
) => {
  const colorChar = color === 'white' ? 'W' : 'B';
  return `https://my5.eapptrack.com/eapptrack/v5images/48/${colorChar}/${fileName}`;
};

/**
 *
 * @param min minimum is inclusive
 * @param max maximum is exclusive
 * @returns random integer
 */
export const getRandomInt = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
};
